/* eslint-disable @typescript-eslint/no-explicit-any */
export function jsonClone(obj: any) {
  return JSON.parse(JSON.stringify(obj))
}

export function mappingMessageCode(msg: string, prefixCode: number | string, codeError: number | string): string {
  const checkUndefined = codeError === undefined && codeError === null ? '' : codeError
  const message = `${msg} (${prefixCode}${checkUndefined})`
  return message
}
